<template>
  <v-container id="dashboard" tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row justify="end" class="pr-2">
      <v-col cols="12" sm="auto">
        <v-btn x-large color="success" class="text-white" width="100%" @click="onPrint"
          ><v-icon right dark class="mr-2"> mdi-update </v-icon>
          In liên giao
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn
          x-large
          color="success"
          class="text-white"
          width="100%"
          @click="onPrintCuaHang"
          ><v-icon right dark class="mr-2"> mdi-update </v-icon>
          In liên lưu
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn
          color="error"
          x-large
          class="text-white"
          min-width="180"
          width="100%"
          button
          dark
          @click="actionsDelete"
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Xoá bỏ
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn
          color="primary"
          x-large
          class="text-white"
          min-width="180"
          width="100%"
          button
          dark
          @click="updateDeviceInfo"
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Cập nhật
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn x-large color="purple" class="text-white" width="100%" @click="onCreate"
          ><v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Tạo sao chép
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="px-8 py-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row justify="space-between" class="mb-4">
              <v-col cols="12" sm="3">
                <h2 class="text-xl font-medium">Chi tiết sửa chữa</h2>
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-select
                  v-model="deliveryStatus"
                  prepend-inner-icon="mdi-list-status"
                  color="#FBB040"
                  :items="deliveryStatusList"
                  outlined
                  :rules="[rules.required]"
                  no-data-text="Không có dữ liệu"
                  label="Trạng thái*"
                  item-text="name"
                  loading="true"
                  item-value="id"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <DatePicker
                  :rules="[rules.required]"
                  v-model="receivedDate"
                  label="Ngày nhận*"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <DatePicker
                  :rules="[rules.required]"
                  v-model="fixedPlanDate"
                  label="Ngày dự kiến trả*"
                /> </v-col
            ></v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productName"
                  :rules="[rules.required]"
                  outlined
                  prepend-inner-icon="mdi-numeric"
                  color="#FBB040"
                  label="Tên sản phẩm*"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productIMEI"
                  outlined
                  prepend-inner-icon="mdi-passport-biometric"
                  color="#FBB040"
                  label="IMEI"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productLockScreen"
                  outlined
                  prepend-inner-icon="mdi-counter"
                  color="#FBB040"
                  label="Mật khẩu khoá màn hình"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="customerName"
                  outlined
                  prepend-inner-icon="mdi-account"
                  color="#FBB040"
                  label="Tên khách hàng*"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="customerPhone"
                  outlined
                  prepend-inner-icon="mdi-phone"
                  color="#FBB040"
                  label="Số điện thoại"
                  :hide-details="isMobile"
                  :maxLength="20"
                  @keypress="filter(evt)"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productGuarran"
                  outlined
                  prepend-inner-icon="mdi-account-child"
                  color="#FBB040"
                  label="Bảo hành*"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-textarea
                  rows="1"
                  auto-grow
                  v-model="receiveStatus"
                  prepend-inner-icon="mdi-import"
                  outlined
                  label="Tình trạng tiếp nhận"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-select
                  v-model="fixStatus"
                  prepend-inner-icon="mdi-auto-fix"
                  color="#FBB040"
                  :items="fixStatusList"
                  outlined
                  :rules="[rules.required]"
                  no-data-text="Không có dữ liệu"
                  label="Tình trạng sửa chữa*"
                  item-text="name"
                  loading="true"
                  item-value="id"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-textarea
                  rows="1"
                  auto-grow
                  v-model="fixContent"
                  prepend-inner-icon="mdi-content-save-cog"
                  outlined
                  label="Nội dung sửa chữa"
                /> </v-col
            ></v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <money-input
                  v-model="priceFix"
                  v-bind:label="label"
                  v-bind:placeholder="placeholder"
                  v-bind:readonly="readonly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                  v-bind:options="options"
                  v-bind:properties="properties"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <money-input
                  v-model="addCost"
                  v-bind:label="labelChiPhi"
                  v-bind:placeholder="placeholder"
                  v-bind:readonly="readonly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                  v-bind:options="options"
                  v-bind:properties="properties"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="technicianId"
                  outlined
                  prepend-inner-icon="mdi-currency-twd"
                  color="#FBB040"
                  label="Kỹ thuật viên"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="12" lg="12">
                <v-textarea
                  rows="1"
                  auto-grow
                  v-model="note"
                  prepend-inner-icon="mdi-note-alert-outline"
                  outlined
                  hide-details
                  label="Lưu ý"
                /> </v-col
            ></v-row>
            <template> </template>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { mapState } from "vuex";
import MoneyInput from "~/components/atoms/MoneyInput.vue";
import { required } from "~/utils/validation";
import DatePicker from "~/components/atoms/DatePicker.vue";
import VueUploadMultipleImage from "~/components/molecules/VueUploadMultipleImage.vue";

export default {
  name: "DeviceDetail",
  components: { MoneyInput, DatePicker, VueUploadMultipleImage },
  data() {
    return {
      scope: "device",
      label: "Giá sửa chữa",
      labelChiPhi: "Chi phí",
      valid: true,
      rules: {
        required,
      },
      placeholder: " ",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: true,
      valueWhenIsEmpty: "",
      options: {
        locale: "it-IT",
        prefix: "",
        suffix: "vnđ",
        length: 30,
        precision: 0,
      },
      properties: {
        hint: "Chú ý đơn vị tính",
        prependInnerIcon: "mdi-currency-usd",
        color: "#FBB040",
      },
      priceFix: null,
      addCost: 0,
      technicianId: null,
      productName: null,
      productIMEI: null,
      productGuarran: null,
      receiveStatus: null,
      note: null,
      productLockScreen: null,
      customerName: null,
      customerPhone: null,
      fixStatus: 1,
      fixContent: null,
      fixStatusList: [
        {
          id: 1,
          name: "Bảo hành sửa",
        },
        {
          id: 2,
          name: "Đang sửa",
        },
        {
          id: 3,
          name: "Chờ linh kiện",
        },
        {
          id: 4,
          name: "Đã sửa xong",
        },
        {
          id: 5,
          name: "Chờ giao cho khách",
        },
        {
          id: 6,
          name: "Không sửa được",
        },
        {
          id: 7,
          name: "Kiểm tra báo giá",
        },
        {
          id: 8,
          name: "Khách không sửa",
        },
        {
          id: 9,
          name: "Thu lại máy",
        },
      ],
      deliveryStatusList: [
        {
          id: 1,
          name: "Mới tạo",
        },
        {
          id: 2,
          name: "Đang sửa",
        },
        {
          id: 3,
          name: "Hoàn thành",
        },
      ],
      deliveryStatus: 1,
      isLoading: false,
      isLoadingActions: false,
      messageError: EMPTY,
      receivedDate: null,
      fixedPlanDate: null,
      isDeleteable: false,
    };
  },
  computed: {
    ...mapState({
      images: (state) => state.device.images,
      totalImage: (state) => state.device.totalImage,
    }),
    isMobile() {
      return window.innerWidth <= 640 ? true : false;
    },
  },
  async created() {
    Date.prototype.addDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
    this.receivedDate = new Date().toLocaleDateString("vi-VN").replaceAll("/", "-");
    this.fixedPlanDate = new Date().toLocaleDateString("vi-VN").replaceAll("/", "-");
    await this.fetchDetailPhoneFix();
  },
  methods: {
    async onCreate() {
      await this.$refs.form.validate();
      if (this.valid) {
        try {
          this.isLoadingActions = true;
          if (this.addCost == null) {
            this.addCost = 0;
          }
          await this.$services.phonefixService.createPhoneFix({
            receivedDate: this.receivedDate,
            fixedPlanDate: this.fixedPlanDate,
            receiveStatus: this.receiveStatus,
            productName: this.productName,
            productIMEI: this.productIMEI,
            productLockScreen: this.productLockScreen,
            customerName: this.customerName,
            customerPhone: this.customerPhone,
            techniciansId: this.technicianId,
            fixContent: this.fixContent,
            priceFix: this.priceFix,
            guarrantyDate: this.productGuarran,
            fixStatus: this.fixStatus,
            deliveryStatus: this.deliveryStatus,
            note: this.note,
            addCost: this.addCost,
          });
        } catch (error) {
          console.log(error);
        } finally {
          this.isLoadingActions = false;
          this.$router?.push({ name: "PhoneFixList" });
        }
      }
    },
    async actionsDelete() {
      this.$modal.show({
        title: "Xác nhận xoá sửa chữa này?",
        visible: true,
        callbackConfirm: async () => this.deleteDeviceById(),
      });
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async deleteDeviceById() {
      const { phonefixId } = this.$route.params;
      try {
        this.isLoadingActions = true;
        await this.$services.phonefixService.deletePhoneFixByID(phonefixId);
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
        this.$router.push({ name: "PhoneFixList" });
      }
    },
    onPrint() {
      const { phonefixId } = this.$route.params;
      const routeData = this.$router.resolve({
        name: "PhieuSuaChua",
        params: { phonfixid: phonefixId },
      });
      window.open(routeData.href, "_blank");
    },
    onPrintCuaHang() {
      const { phonefixId } = this.$route.params;
      const routeData = this.$router.resolve({
        name: "PhieuSuaChuaCuaHang",
        params: { phonfixid: phonefixId },
      });
      window.open(routeData.href, "_blank");
    },
    async fetchDetailPhoneFix() {
      this.isLoading = true;
      try {
        const { phonefixId } = this.$route.params;
        const data = await this.$services.phonefixService.getPhoneFix(phonefixId);
        if (data) {
          this.receivedDate = data?.receiveDate;
          this.fixedPlanDate = data?.fixedPlanDate;
          this.productName = data?.productName;
          this.productIMEI = data?.productIMEI;
          this.productLockScreen = data?.productLockScreen;
          this.customerName = data?.customerName;
          this.customerPhone = data?.customerPhone;
          this.receiveStatus = data?.receiveStatus;
          this.technicianId = data?.technicianId;
          this.fixContent = data?.fixContent;
          this.priceFix = data?.priceFix;
          this.productGuarran = data?.guarrantyDateName;
          this.fixStatus = parseInt(data?.fixStatus);
          this.deliveryStatus = parseInt(data?.deliveryStatus);
          this.note = data?.note;
          this.addCost = data?.addCost;
        }
      } catch {
      } finally {
        this.isLoading = false;
      }
    },
    async updateDeviceInfo() {
      await this.$refs.form.validate();
      if (this.valid) {
        try {
          this.isLoadingActions = true;
          const publicIdList = this.images.map((element) => element.publicId);
          const { phonefixId } = this.$route.params;
          if (this.addCost === "") {
            this.addCost = 0;
          }
          if (this.priceFix === "") {
            this.priceFix = null;
          }
          await this.$services.phonefixService.updatePhoneFix(phonefixId, {
            receivedDate: this.receivedDate,
            fixedPlanDate: this.fixedPlanDate,
            receiveStatus: this.receiveStatus,
            productName: this.productName,
            productIMEI: this.productIMEI,
            productLockScreen: this.productLockScreen,
            customerName: this.customerName,
            customerPhone: this.customerPhone,
            techniciansId: this.technicianId,
            fixContent: this.fixContent,
            priceFix: this.priceFix,
            guarrantyDate: this.productGuarran,
            fixStatus: this.fixStatus,
            deliveryStatus: this.deliveryStatus,
            note: this.note,
            addCost: this.addCost,
          });
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoadingActions = false;
        }
      }
    },
  },
};
</script>
